import FieldWithDateValueController from '../fieldWithDateValue.controller';

class TimeFieldController extends FieldWithDateValueController {
  constructor($scope, $q, $translate, $log, $timeout, DateTimeService, LogService) {
    "ngInject";
    super($scope, $q, $translate, $log, $timeout, DateTimeService, LogService);
  }

  $onInit() {
    super.$onInit();
  }

  get timeValue() {
    return this.dateValueShiftedForEventTimezone;
  }

  set timeValue(dateValue) {
    this.dateValueShiftedForEventTimezone = dateValue;
    console.debug(`TimeFieldController set timeValue to '${this.dateValueShiftedForEventTimezone}' from input '${dateValue}'`, this.value, dateValue);
  }
}

export default TimeFieldController;
